import $ from 'jquery';
import LocomotiveScroll from "locomotive-scroll";
import lazyLoadDirective from "../directives/scroll/lazy-load";
import {dependency} from "../utils/request";

export default function locoScroll() {
	const $lazyMedia = $('[sw-lazy-load]');
	const $menuLabel = $('.hamburger-label, .header-logo_text');
	const $menuArrow = $('.menu-arrow');

	let scroll;
	let lazyLoad;
	let btt = $('.footer-main-btt_button');

	requestCountJs();
	requestMuuri();

	$lazyMedia.attr('data-scroll', '');
	$lazyMedia.attr('data-scroll-call', 'lazyLoadMedia');

	scroll = new LocomotiveScroll({
		el: document.querySelector('[data-scroll-container]'),
		smooth: true,
		getDirection: true,
		getSpeed: true
	});

	lazyLoad = lazyLoadDirective();
	// $(()=>{lazyLoad.revalidate();});

	btt.off('click');
	btt.click(() => {
		scroll.scrollTo('top');
	});

	scroll.on('call', func => {
		if (typeof func === 'string') {
			switch (func) {
				case 'lazyLoadMedia':
					let elements = $('.is-inview[data-scroll-call="lazyLoadMedia"][sw-lazy-load]');
					lazyLoad.load(elements);
					break;
				case 'countUp':
					createCountUp();
					break;
			}
		}
	});

	scroll.on('scroll', ({limit, direction, scroll}) => {
		let maxBottom = limit - 300;

		$menuLabel.css({
			opacity: function () {
				return 1 - (scroll.y/100);
			}
		});

		$menuArrow.css({
			opacity: function () {

				if (scroll.y < maxBottom) {
					return 1;
				} else {
					return 1 - (scroll.y/maxBottom);
				}
			}
		});
	});

	setupHashLinks(scroll);
	setupSwipers(scroll);
	updateMuuri(scroll);
	animateLoadingInit();

	return {
		'scroll': scroll,
		'lazy': lazyLoad
	};
}

function setupSwipers(scroll) {
	const $swipers = $('[sw-swiper]');

	if ($swipers.length > 0) {
		$swipers.each(function () {
			const $element = $(this);
			$element.on('swiperReady', function () {
				scroll.update();
			});
		});
	}
}

function setupHashLinks(scroll) {
	const $links = $('[href^="#"]');

	if ($links.length) {
		$links.on('click', function (e) {
			e.preventDefault();
			const $this = $(this);
			let href = $this.attr('href').replace('#', '');
			const el = document.getElementById(href);

			scroll.scrollTo(el, -100);
		});
	}
}

function createCountUp() {
	const $elements = $('.is-inview[sw-count]:not(".added")');

	if ($elements.length) {
		$elements.each(function() {
			const $this = $(this);
			const $el = $this.find('.stats-count-number');
			const number = $this.attr('data-number');

			if (window.CountUp && CountUp) {
				let count = new CountUp($el.attr('id'), 0, parseInt(number), 0, 2);

				if (!count.error) {
					count.start();
				} else {
					console.error(count.error);
				}
			} else {
				$el.html(number);
			}

			$this.addClass('added');
		});
	}
}

function requestCountJs() {
	const $countItems = $('[sw-count]');
	if ($countItems.length && !(window.CountUp && CountUp)) {
		dependency('https://cdnjs.cloudflare.com/ajax/libs/countup.js/1.8.2/countUp.min.js', () => window.CountUp && CountUp);
	}
}

function requestMuuri() {
	const $muuri = $('.muuri');

	if ($muuri.length) {
		if (!(window.Muuri && Muuri)) {
			dependency('https://cdn.jsdelivr.net/npm/muuri@0.9.3/dist/muuri.min.js', () => window.Muuri && Muuri).then(()=>{
				setupMuuri();
			});
		} else {
			setupMuuri();
		}
	}
}

function setupMuuri() {
	const $catLinks = $('.heading-categories a');
	const $catLi = $('.heading-categories li');

	const grid = new Muuri('.muuri', {
		itemClass: 'insights-list-item',
	});

	grid.on('layoutEnd', function () {
		$('.muuri').trigger('updateMuuri');
	});

	$catLinks.click(function(e) {
		e.preventDefault();

		const $this = $(this);
		const li = $this.parent();
		const cat = $this.attr('data-cat');

		grid.filter(`[data-${cat}]`);

		$catLi.removeClass('-active');
		li.addClass('-active');
	});
}

function updateMuuri(scroll) {
	const $muuri = $('.muuri');

	$muuri.on('updateMuuri', function () {
		scroll.update();
	});
}

function animateLoadingInit() {
	const $loadingContainer = $('.loading');

	if ($loadingContainer.length) {
		const $loadingBg = $('.loading-bg'), $loadingLogo = $('.loading-logo');

		let animateOnEvents = 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd';

		if ($loadingContainer.length) {
			$loadingBg.on(animateOnEvents, function(e){
				if (e.target === this) {
					$loadingLogo.removeClass('-hidden');
				}
			});

			$loadingContainer.on(animateOnEvents, function(e) {
				if (e.target === this) {
					$loadingContainer.off();
					$loadingContainer.remove();
				}
			});

			$loadingLogo.on(animateOnEvents, function(e) {
				if (e.target === this) {
					$loadingBg.off();
					$loadingLogo.off();
					// $loadingContainer.fadeOut(1000);
					$loadingContainer.addClass('-closed');
					setTimeout(()=>{
						$('#content').addClass('-show');
					}, 500);
				}
			});

			$loadingBg.removeClass('-hidden');
		}
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/locoScroll.js